import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getMenuRequest, getMenuRequestError, getMenuRequestSuccess } from "../../slices/Menu/GetMenuListSlice";

export const GetMenuApi = (page, limit, status, search, day) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        status: status,
        search: search,
        day
    }).toString();

    const urlWithParams = `${endpoints.getMenuList}?${queryParams}`;

    try {
        dispatch(getMenuRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getMenuRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getMenuRequestError(_error));
            });
    } catch (error) {
    }
};
